import React, { useState } from "react";
import InputBox from "../../../components/InputBox";
import { Button } from "src/business-types/grocery/components/Button";
import { notifyError } from "../../../../../assets/toastService";
import PopupModules from "src/features/auth/components/PopupModules";
import { errorHandling } from "src/shared/services/errorHandling";
import { CategoryV2 } from "src/shared/types";
import useCategory from "src/business-types/grocery/hooks/useCategory";

type Props = {
    close: (data: any) => void;
    loading: (data: boolean) => void;
    isOpen: boolean;
    editData?: CategoryV2;
};

function AddEditCategory({ close, loading, isOpen, editData }: Props) {
    const isEdit = !!editData;
    const { post, edit } = useCategory()
    const [categoryName, setCategoryName] = useState(editData?.name.trim() ?? "");
    const [secondName, setSecondName] = useState(editData?.secondName?.trim() ?? "");
    const [multiples, setMultiples] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const isUnchanged =
        isEdit &&
        categoryName.trim() === editData.name.trim() &&
        secondName.trim() === (editData.secondName?.trim() ?? "");

    const handleConfirm = async () => {
        const trimmedName = categoryName.trim();
        if (!trimmedName) return notifyError("Category name cannot be empty.");
        if (isSubmitting) return;

        try {
            setIsSubmitting(true);
            const updateData = { categoryName: trimmedName, categorySecondName: secondName.trim() }
            if (isEdit) {
                edit(editData._id.$oid, updateData, () => close("Updated"));
            } else {
                post({ categoryName: trimmedName, categorySecondName: secondName.trim() }, () => {
                    setCategoryName("");
                    setSecondName("");
                    if (!multiples) close("Updated");;
                });

            }
        } catch (error: any) {
            errorHandling(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <PopupModules isOpen={isOpen} onClose={() => close("")} title={isEdit ? "Edit category" : "Add new category"}>
            <div className="flex flex-col gap-3 m-3">
                <label className="text-sm font-medium text-gray-700 px-1">Category name</label>
                <InputBox
                    maxLength={40}
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    placeholder="Enter category name"
                />

                <label className="text-sm font-medium text-gray-700 px-1">Second name</label>
                <InputBox
                    maxLength={40}
                    value={secondName}
                    onChange={(e) => setSecondName(e.target.value)}
                    placeholder="Enter second name"
                />

                {!isEdit && (
                    <label className="flex items-center gap-2 cursor-pointer text-sm text-gray-600">
                        <input
                            type="checkbox"
                            className="w-5 h-5"
                            checked={multiples}
                            onChange={() => setMultiples((p) => !p)}
                        />
                        Add multiple categories
                    </label>
                )}

                <div className="flex justify-center gap-3 mt-3">
                    <Button label="Cancel" variant="ThemeCancel" className="border" onClick={() => close("")} />
                    <Button
                        label={isEdit ? (isSubmitting ? "Updating..." : "Update") : "Confirm"}
                        variant="ThemeBase"
                        onClick={handleConfirm}
                        disabled={isSubmitting || !categoryName.trim() || isUnchanged}
                    />
                </div>
            </div>
        </PopupModules>
    );
}

export default AddEditCategory;